import type { TableColumns } from '@ohpen/enso-ui';
import { FirmGetAllResponse, FieldType, FirmDraftDataRow, type FirmsSqeFilterNode } from '@pmp/api';
import type { SqeFields, SqeSort } from '@pmp/utils';

export const columns: TableColumns<FirmGetAllResponse> = [
  {
    title: 'firms.labels.ohpenId',
    dataIndex: 'ohpenId',
    key: 'id',
    width: 300,
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'firms.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 300,
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'firms.labels.isAuthorised',
    dataIndex: 'isAuthorised',
    key: 'isAuthorised',
    width: 140,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
      hide: true,
    },
  },
  {
    title: 'firms.labels.reference',
    dataIndex: 'reference',
    key: 'reference',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'firms.labels.type',
    dataIndex: 'type',
    key: 'type',
    width: 180,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.FIRM_TYPE,
      sorter: true,
    },
  },
  {
    title: 'firms.labels.frn',
    dataIndex: 'frn',
    key: 'frn',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'firms.labels.nacfbNumber',
    dataIndex: 'nacfbNumber',
    key: 'nacfbNumber',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'firms.labels.fcaStatus',
    dataIndex: 'fcaStatus',
    key: 'fcaStatus',
    width: 240,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'firms.labels.principalFirm',
    dataIndex: 'principalFirm',
    key: 'principalFirm',
    width: 200,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.PRINCIPALS,
      hide: true,
    },
  },
  {
    title: 'firms.labels.operations',
    dataIndex: 'operationsWhitelist',
    key: 'operationsWhitelist',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.OPERATION_TYPE,
    },
  },
  {
    title: 'firms.labels.btl',
    dataIndex: 'btl',
    key: 'btl',
    width: 190,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.CASE_PERMISSION_TYPE,
    },
  },
  {
    title: 'firms.labels.rbtl',
    dataIndex: 'rbtl',
    key: 'rbtl',
    width: 180,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.CASE_PERMISSION_TYPE,
    },
  },
  {
    title: 'firms.labels.rmc',
    dataIndex: 'rmc',
    key: 'rmc',
    width: 160,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.CASE_PERMISSION_TYPE,
    },
  },
  {
    title: 'firms.labels.firmCompliance',
    dataIndex: 'firmCompliance',
    key: 'complianceStatus',
    width: 150,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.COMPLIANCE_STATUS,
    },
  },
  {
    title: 'firms.labels.isActive',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'firms.labels.defaultPaymentRoute',
    dataIndex: 'defaultPaymentRouteFirm',
    key: 'defaultPaymentRouteFirm',
    width: 180,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      sorter: true,
    },
  },
  {
    title: 'firms.labels.activationDate',
    dataIndex: 'activationDate',
    key: 'activationDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'firms.labels.deactivationDate',
    dataIndex: 'deactivationDate',
    key: 'deactivationDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const firmCRColumns: TableColumns<FirmDraftDataRow> = [
  {
    title: 'firms.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    options: {
      sorter: true,
    },
  },
  {
    title: 'firms.labels.type',
    dataIndex: 'type',
    key: 'type',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.FIRM_TYPE,
      sorter: true,
    },
  },
  {
    title: 'firms.labels.isActive',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'firms.labels.reference',
    dataIndex: 'reference',
    key: 'reference',
    width: 120,
    options: {
      sorter: true,
    },
  },
  {
    title: 'firms.labels.frn',
    dataIndex: 'frn',
    key: 'frn',
    width: 120,
    options: {
      sorter: true,
    },
  },
];

export const firmSqeFields: SqeFields<FirmsSqeFilterNode> = {
  ohpenId: { kind: 'text' },
  name: { kind: 'text' },
  isAuthorised: { kind: 'boolean' },
  reference: { kind: 'text', nullable: true },
  type: { kind: 'enum' },
  frn: { kind: 'identifier', nullable: true },
  nacfbNumber: { kind: 'text', nullable: true },
  fcaStatus: { kind: 'text', nullable: true },
  principalFirm: { kind: 'collection', key: 'id', search: 'name' },
  operationsWhitelist: { kind: 'collection', key: 'key' },
  btl: { kind: 'enum' },
  rbtl: { kind: 'enum' },
  rmc: { kind: 'enum' },
  firmCompliance: { kind: 'enum' },
  isActive: { kind: 'boolean' },
  defaultPaymentRouteFirm: { kind: 'reference', nullable: true },
  activationDate: { kind: 'date', nullable: true },
  deactivationDate: { kind: 'date', nullable: true },
};

export const firmSqeDefaultSort: SqeSort = [{ field: 'name', dir: 'asc' }];
